import { ShowDialog } from './src/main.js'
export { ShowDialog }



// WEBPACK FOOTER //
// ./src/components/DialogManager/index.js